module.exports = __webpack_public_path__ + "img/music_015.788eefbd.png";